const LearnMore: React.FC = () => {
    return (
        <p style={{color: "var(--color-accent-dark", textDecoration: "underline"}}>Learn More</p>
    );
}

export default LearnMore;